import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faFolder} from '@fortawesome/pro-solid-svg-icons';
import {CategoriesLabel} from '../locales';

export const categoriesActionRouteIcon = faFolder;

/**
 * Goto categories
 * @param params
 * @returns Action
 */
export const categoriesActionRoute = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'categories-route',
	cb: () => dispatcher.trigger('nx:folders'),
	icon: categoriesActionRouteIcon,
	get label() {
		return CategoriesLabel.ROUTE;
	},
	routeMatch: /^category(\/?)/,
	...params,
});

export default categoriesActionRoute;
